export default __webpack_public_path__ + "images/af06c03717692a0e8b7e648420d65f51.png";